module.exports = __webpack_public_path__ + "media/newstyle/images/quadrado-c8f136f59bc54b82d5265853c9a87548.svg";